module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.title,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.desc) ? _c('p', {
    staticClass: "reason-desc"
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e(), _vm._v(" "), (_vm.kindOptions && _vm.kindOptions.length) ? _c('div', {
    staticClass: "reason-kind"
  }, [_c('div', {
    staticClass: "reason-label"
  }, [_vm._v(_vm._s(_vm.kindLabel) + " "), _c('span', {
    staticClass: "reason-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "transfer": "",
      "placeholder": _vm.kindPlaceholder
    },
    model: {
      value: (_vm.kind),
      callback: function($$v) {
        _vm.kind = $$v
      },
      expression: "kind"
    }
  }, _vm._l((_vm.kindOptions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reason-label"
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('span', {
    staticClass: "reason-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fbf580e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/modal/RecruitReasonModal.vue
// module id = 1823
// module chunks = 8